// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2dxPO","card":"Cards_card__T_r_O","infected":"Cards_infected__1zbhT","recovered":"Cards_recovered__16VsY","deaths":"Cards_deaths__29pcU"};